import { disableBodyScroll, enableBodyScroll } from 'body-scroll-lock';
import * as React from 'react';
import { NavLink, RouteComponentProps, withRouter } from 'react-router-dom';
import Slider from 'react-slick';

import { ProgressBar } from './ProggressBar';

// import facebookIcon from '../assets/images/icon-social-facebook.svg';
// import instagramIcon from '../assets/images/icon-social-instagram.svg';
// import youtubeIcon from '../assets/images/icon-social-youtube.svg';
// import xIcon from '../assets/images/icon-social-x.svg';
import { ReactComponent as UpArrow } from '../assets/icons/up-arrow-svgrepo-com.svg';

interface NavigationState {
  isMenuToggled: boolean;
  isProductsOpen: boolean;
  hasSlickArrows: boolean;
}

type Props = RouteComponentProps<any>;

class Navigation extends React.Component<Props, NavigationState> {
  state = {
    isMenuToggled: false,
    isProductsOpen: false,
    hasSlickArrows: false,
  };

  private targetElement: Element | null = null;
  private outsideClickRef = React.createRef<HTMLDivElement>();
  private excludeRef = React.createRef<HTMLLIElement>();
  private excludeRef2 = React.createRef<HTMLLIElement>();
  private productsSliderRef = React.createRef<HTMLDivElement>();
  private resizeTimeout: number | null = null;

  componentDidMount() {
    this.targetElement = document.querySelector('.nav__links');
    document.addEventListener('mousedown', this.handleClickOutside);
    window.addEventListener('resize', this.handleResize);
    this.checkForSlickArrows();
  }

  componentWillUnmount() {
    this.unlockScroll();

    document.removeEventListener('mousedown', this.handleClickOutside);
    window.removeEventListener('resize', this.handleResize);
    this.checkForSlickArrows();
  }

  handleResize = () => {
    if (this.resizeTimeout) {
      clearTimeout(this.resizeTimeout);
    }
    this.resizeTimeout = window.setTimeout(() => {
      this.checkForSlickArrows();
    }, 0);
  };

  checkForSlickArrows = () => {
    if (this.productsSliderRef.current) {
      const hasArrows = !!this.productsSliderRef.current.querySelector(
        '.slick-arrow',
      );
      if (hasArrows !== this.state.hasSlickArrows) {
        this.setState({ hasSlickArrows: hasArrows });
      }
    }
  };

  handleClickOutside = (event: any) => {
    if (
      this.outsideClickRef.current &&
      !this.outsideClickRef.current.contains(event.target) &&
      !(
        this.excludeRef.current &&
        this.excludeRef.current.contains(event.target)
      ) &&
      !(
        this.excludeRef2.current &&
        this.excludeRef2.current.contains(event.target)
      )
    ) {
      this.setState({ isProductsOpen: false });
      if (!this.state.isMenuToggled) {
        this.removeBodyLock();
      }
    }
  };

  private scrollEventListeners: {
    type: string;
    handler: (e: Event) => void;
  }[] = [];

  componentDidUpdate(prevProps: Props, prevState: NavigationState) {
    const { isProductsOpen } = this.state;

    if (prevState.isProductsOpen !== isProductsOpen) {
      if (isProductsOpen) {
        this.lockScroll();
      } else {
        this.unlockScroll();
      }
    }

    const { pathname } = this.props.location;
    if (pathname !== prevProps.location.pathname) {
      this.removeBodyLock();
      this.setState({
        isMenuToggled: false,
      });
      document.body.classList.remove('is-locked');
      document.documentElement.classList.remove('is-locked');
    }

    const glassEffectElement = document.getElementById('glass__effect');

    if (glassEffectElement) {
      if (isProductsOpen) {
        glassEffectElement.style.display = 'block'; // 👈 Ensure it is visible
      } else {
        glassEffectElement.style.display = 'none'; // 👈 Hide it
      }
    }
  }

  lockScroll = () => {
    if (window.innerWidth < 992) return;

    const preventDefault = (e: Event) => {
      e.preventDefault();
      e.stopPropagation();
      return false;
    };

    const events = ['wheel', 'touchmove', 'keydown', 'scroll'];

    events.forEach(eventType => {
      const handler = (e: Event) => {
        if (this.productsSliderRef.current?.contains(e.target as Node)) {
          return true;
        }
        return preventDefault(e);
      };

      document.addEventListener(eventType, handler, { passive: false });
      this.scrollEventListeners.push({ type: eventType, handler });
    });
  };

  unlockScroll = () => {
    this.scrollEventListeners.forEach(({ type, handler }) => {
      document.removeEventListener(type, handler);
    });
    this.scrollEventListeners = [];
  };

  preventDefault = (e: any) => {
    e.preventDefault();
  };

  handleMenuToggle = () => {
    const { isMenuToggled } = this.state;
    this.setState({ isMenuToggled: !isMenuToggled });
    if (isMenuToggled) {
      this.removeBodyLock();
    } else {
      document.body.classList.add('is-locked');
      document.documentElement.classList.add('is-locked');
      disableBodyScroll(this.targetElement);
    }
  };

  removeBodyLock = () => {
    document.body.classList.remove('is-locked');
    document.documentElement.classList.remove('is-locked');
    enableBodyScroll(this.targetElement);

    this.setState({ isProductsOpen: false });
  };

  handleBlur = (event: any) => {
    event.currentTarget ? event.currentTarget.blur() : event.srcElement.blur();
  };

  handleProductsToggle = () => {
    const { isProductsOpen } = this.state;

    if (isProductsOpen && !this.state.isMenuToggled) {
      this.setState({ isProductsOpen: false });
    } else {
      this.setState({ isProductsOpen: true });
    }

    this.setState({ isProductsOpen: !isProductsOpen });
  };
  handleNavigationClick = () => {
    this.setState({ isProductsOpen: false });
    this.removeBodyLock();
  };

  render() {
    const { isMenuToggled, isProductsOpen, hasSlickArrows } = this.state;

    const settings: any = {
      autoplay: false,
      dots: true,
      speed: 500,
      centerPadding: '60px',
      slidesToShow: 9,
      infinite: false,
      arrows: true,
      swipe: false,
      swipeToSlide: false,
      height: '180px',
      gap: '43px',
      slidesToScroll: 1,
      responsive: [
        { breakpoint: 2200, settings: { slidesToShow: 8 } },
        { breakpoint: 1920, settings: { slidesToShow: 7 } },
        { breakpoint: 1675, settings: { slidesToShow: 6 } },
        { breakpoint: 1370, settings: { slidesToShow: 5 } },
        { breakpoint: 1150, settings: { slidesToShow: 4 } },
      ],
    };

    const activeLocation = this.props.location.pathname;

    return (
      <>
        <nav className={`nav ${isMenuToggled ? 'is-open' : ''}`}>
          <div className={`nav__links ${isMenuToggled ? 'is-open' : ''}`}>
            <div
              style={{
                opacity: isProductsOpen ? '1' : '0',
                pointerEvents: isProductsOpen ? 'inherit' : 'none',
                position: 'absolute',
                transition: 'all .2s ease-out',
                top: '49px',
                zIndex: 7,
                backgroundColor: 'black',
              }}
              ref={this.outsideClickRef}
              className="products__nav__parent"
              id="nav__products__wrapper"
            >
              <div
                style={{
                  width: '90%',
                  margin: hasSlickArrows ? '0 auto' : '0',
                  minHeight: '250px',
                  textAlign: 'center',
                  transition: 'all 0.3s ease',
                }}
                ref={this.productsSliderRef}
                className="products__slider"
              >
                <Slider {...settings}>
                  <div className="image__block">
                    <NavLink
                      to={'/products/mrm1-5'}
                      onClick={this.handleNavigationClick}
                      onMouseLeave={this.handleBlur}
                      className="products__dropdown__nav"
                    >
                      <div className="products__image--wrapper">
                        <img
                          src={require('main/assets/images/mrm1-5/mrm1-5-product.webp')}
                          alt="Professional Tactical Drone"
                          className="products__dropdown__image"
                          style={{ objectFit: 'contain' }}
                        />
                      </div>
                      <span>MRM1-5</span>
                    </NavLink>
                  </div>
                  <div className="image__block">
                    <NavLink
                      to={'/products/mrm2-10'}
                      onClick={this.handleNavigationClick}
                      onMouseLeave={this.handleBlur}
                      className="products__dropdown__nav"
                    >
                      <div className="products__image--wrapper">
                        <img
                          src={require('main/assets/images/mrm2-10/top-view-drone.webp')}
                          alt="Professional Tactical Drone"
                          className="products__dropdown__image"
                          style={{ objectFit: 'contain' }}
                        />
                      </div>
                      <span>MRM2-10</span>
                    </NavLink>
                  </div>
                  <div className="image__block">
                    <NavLink
                      to={'/products/h7-wingcore'}
                      onClick={this.handleNavigationClick}
                      onMouseLeave={this.handleBlur}
                      className="products__dropdown__nav"
                    >
                      <div className="products__image--wrapper">
                        <img
                          src={require('main/assets/images/wingcore/h7-wingcore-product.webp')}
                          alt="Professional Tactical Drone"
                          className="products__dropdown__image"
                          style={{ objectFit: 'contain' }}
                        />
                      </div>
                      <span>H7 Wingcore</span>
                    </NavLink>
                  </div>
                  {/* 
                  <div className="image__block">
                    <NavLink
                      to={'/products/dreamx'}
                      onClick={this.handleNavigationClick}
                      onMouseLeave={this.handleBlur}
                      className="products__dropdown__nav"
                    >
                      <div className="products__image--wrapper">
                        <img
                          src={require('main/assets/images/dreamX/DreamX_dron.webp')}
                          alt="FPV Freestyle Drone with Long Range"
                          className="products__dropdown__image"
                        />
                      </div>
                      <span>Dream X</span>
                    </NavLink>
                  </div> */}
                  <div className="image__block">
                    <NavLink
                      to={'/products/fpvonepilot'}
                      onClick={this.handleNavigationClick}
                      onMouseLeave={this.handleBlur}
                      className="products__dropdown__nav"
                    >
                      <div className="products__image--wrapper">
                        <img
                          src={require('main/assets/images/fpvonepilot/fpvone-pilot-navigation.webp')}
                          alt="FPV Goggles Product"
                          className="products__dropdown__image"
                        />
                      </div>
                      <span>FPV.One Pilot</span>
                    </NavLink>
                  </div>
                  {/* <div className="image__block">
                    <NavLink
                      to="/products/fpvonerace"
                      onClick={this.handleNavigationClick}
                      onMouseLeave={this.handleBlur}
                      exact
                      className="products__dropdown__nav"
                    >
                      <div className="products__image--wrapper">
                        <img
                          src={require('main/assets/images/fpvonerace/fpvone-race-navigation.webp')}
                          alt="FPV Headset for Racing Product"
                          className="products__dropdown__image"
                        />
                      </div>
                      <span>FPV.One Race</span>
                    </NavLink>
                  </div> */}
                  <div className="image__block">
                    <NavLink
                      to="/products/fpvctrl"
                      onClick={this.handleNavigationClick}
                      onMouseLeave={this.handleBlur}
                      exact
                      className="products__dropdown__nav"
                    >
                      <div className="products__image--wrapper">
                        <img
                          style={{ objectFit: 'contain' }}
                          src={require('main/assets/images/fpvctrl/fpvctrl-full.webp')}
                          alt="FPV Remote Drone Controller"
                          className="products__dropdown__image"
                        />
                      </div>
                      <span>FPV.Ctrl</span>
                    </NavLink>
                  </div>

                  <div className="image__block">
                    <NavLink
                      to={'/products/skydive'}
                      onClick={this.handleNavigationClick}
                      onMouseLeave={this.handleBlur}
                      className="products__dropdown__nav"
                    >
                      <div className="products__image--wrapper">
                        <img
                          src={require('main/assets/images/skydive/skydive-navigation.webp')}
                          alt="FPV Drone Racing and Freestyle Simulator"
                          className="products__dropdown__image"
                        />
                      </div>
                      <span>SkyDive</span>
                    </NavLink>
                  </div>
                  <div className="image__block">
                    <NavLink
                      to={'/products/drone-soccer'}
                      onClick={this.handleNavigationClick}
                      onMouseLeave={this.handleBlur}
                      className="products__dropdown__nav"
                    >
                      <div className="products__image--wrapper">
                        <img
                          src={require('main/assets/images/droneSoccer/drone-soccer-navigation.webp')}
                          alt="Drone Soccer Product"
                          className="products__dropdown__image"
                        />
                      </div>
                      <span>Drone Soccer</span>
                    </NavLink>
                  </div>
                  <div className="image__block">
                    <NavLink
                      to={'/products/fpv-ace'}
                      onMouseLeave={this.handleBlur}
                      className="products__dropdown__nav"
                    >
                      <img
                        src={require('main/assets/images/fpvAce/fpv-ace-navigation.webp')}
                        style={{ objectFit: 'contain' }}
                        alt="FPV Drone Bundle for Flight Guide"
                        className="products__dropdown__image"
                      />
                      <span>FPV.Ace</span>
                    </NavLink>
                  </div>
                  <div className="image__block">
                    <NavLink
                      to={'/products/rapid-fire'}
                      onClick={this.handleNavigationClick}
                      onMouseLeave={this.handleBlur}
                      className="products__dropdown__nav"
                    >
                      <div className="products__image--wrapper">
                        <img
                          src={require('main/assets/images/rapidFire/rapid-fire-design-details.webp')}
                          alt="RF Drone Detection Product"
                          className="products__dropdown__image"
                          style={{ objectFit: 'contain' }}
                        />
                      </div>
                      <span>rapidFIRE</span>
                    </NavLink>
                  </div>
                  <div className="image__block">
                    <NavLink
                      to={'/products/power-meter-v2'}
                      onClick={this.handleNavigationClick}
                      onMouseLeave={this.handleBlur}
                      className="products__dropdown__nav"
                    >
                      <div className="products__image--wrapper">
                        <img
                          src={require('main/assets/images/powerMeterV2/power-meter-navigation.webp')}
                          alt="Testing control and video RF links for FPV using the Power Meter v2."
                          className="products__dropdown__image"
                        />
                      </div>
                      <span>Power Meter v2</span>
                    </NavLink>
                  </div>
                  {/* <div className="image__block">
                    <NavLink
                      to={'/products/lap-rf'}
                      onClick={this.handleNavigationClick}
                      onMouseLeave={this.handleBlur}
                      className="products__dropdown__nav"
                    >
                      <div className="products__image--wrapper">
                        <img
                          src={require('main/assets/images/lapRf/immersionrc-lap-rf-top-side.webp')}
                          alt="Device for RF Drone Detection"
                          className="products__dropdown__image"
                          style={{ objectFit: 'contain' }}
                        />
                      </div>
                      <span>LapRF</span>
                    </NavLink>
                  </div> */}
                </Slider>
              </div>
            </div>

            <ul className="nav__links__top">
              <li
                ref={this.excludeRef2}
                onClick={this.handleProductsToggle}
                className="nav__links__item nav__links__item--sub-nav local--desktop"
              >
                <p
                  className={`nav__link nav__links__item__subtitle nav__links__item__subtitle--secondary ${
                    isProductsOpen ? 'active' : ''
                  }`}
                  style={{
                    paddingLeft: '0px',
                    display: 'flex',
                    alignItems: 'center',
                  }}
                >
                  Products
                  <UpArrow
                    className={`nav__desktop__arrow ${
                      isProductsOpen ? 'nav__mobile__arrow--active' : ''
                    }`}
                  />
                </p>
              </li>

              <li
                ref={this.excludeRef}
                className="nav__links__item nav__links__item--mobile"
              >
                <a
                  onClick={this.handleProductsToggle}
                  className={`nav__link products__nav--mobile ${
                    isProductsOpen ? 'products__nav--mobile--active' : ''
                  }`}
                  target="_blank"
                  role="button"
                  rel="noopener noreferrer"
                  style={{ paddingLeft: '0px' }}
                  onMouseDown={event => event.preventDefault()}
                >
                  <span
                    className={`products__mobile ${
                      isProductsOpen ? 'products__mobile--active' : ''
                    }`}
                  >
                    Products
                  </span>
                  <UpArrow
                    className={`nav__mobile__arrow ${
                      isProductsOpen ? 'nav__mobile__arrow--active' : ''
                    }`}
                  />
                </a>
                <div
                  className={`nav__mobile__list ${
                    isProductsOpen ? 'nav__mobile__list--active' : ''
                  }`}
                >
                  <NavLink
                    to={'/products/mrm1-5'}
                    onClick={() => {
                      this.handleNavigationClick();
                      this.handleMenuToggle();
                    }}
                    onMouseLeave={this.handleBlur}
                    activeClassName="active"
                    className={`nav__mobile__item ${
                      activeLocation === '/products/mrm1-5'
                        ? 'nav__mobile__item--active'
                        : ''
                    }`}
                  >
                    <div className="nav__mobile__image--wrapper">
                      <img
                        src={require('main/assets/images/mrm1-5/mrm1-5-product.webp')}
                        alt="Professional Tactical Drone"
                        className="nav__mobile__image"
                        style={{ objectFit: 'contain' }}
                      />
                    </div>
                    <span
                      style={{ fontSize: '16px' }}
                      className="nav__mobile__title"
                    >
                      MRM1-5
                    </span>
                  </NavLink>
                  <NavLink
                    to={'/products/mrm2-10'}
                    onClick={() => {
                      this.handleNavigationClick();
                      this.handleMenuToggle();
                    }}
                    onMouseLeave={this.handleBlur}
                    activeClassName="active"
                    className={`nav__mobile__item ${
                      activeLocation === '/products/mrm2-10'
                        ? 'nav__mobile__item--active'
                        : ''
                    }`}
                  >
                    <div className="nav__mobile__image--wrapper">
                      <img
                        src={require('main/assets/images/mrm2-10/top-view-drone.webp')}
                        alt="Professional Tactical Drone"
                        className="nav__mobile__image"
                        style={{ objectFit: 'contain' }}
                      />
                    </div>
                    <span
                      style={{ fontSize: '16px' }}
                      className="nav__mobile__title"
                    >
                      MRM2-10
                    </span>
                  </NavLink>
                  <NavLink
                    to={'/products/h7-wingcore'}
                    onClick={() => {
                      this.handleNavigationClick();
                      this.handleMenuToggle();
                    }}
                    onMouseLeave={this.handleBlur}
                    activeClassName="active"
                    className={`nav__mobile__item ${
                      activeLocation === '/products/h7-wingcore'
                        ? 'nav__mobile__item--active'
                        : ''
                    }`}
                  >
                    <div className="nav__mobile__image--wrapper">
                      <img
                        src={require('main/assets/images/wingcore/wingcore-navigation.webp')}
                        alt="Professional Tactical Drone"
                        className="nav__mobile__image"
                        style={{ objectFit: 'contain' }}
                      />
                    </div>
                    <span
                      style={{ fontSize: '16px' }}
                      className="nav__mobile__title"
                    >
                      H7 Wingcore
                    </span>
                  </NavLink>
                  {/* <NavLink
                    to={'/products/dreamx'}
                    onClick={() => {
                      this.handleNavigationClick();
                      this.handleMenuToggle();
                    }}
                    onMouseLeave={this.handleBlur}
                    activeClassName="active"
                    className={`nav__mobile__item ${
                      activeLocation === '/products/dreamx'
                        ? 'nav__mobile__item--active'
                        : ''
                    }`}
                  >
                    <div className="nav__mobile__image--wrapper">
                      <img
                        src={require('main/assets/images/dreamX/DreamX_dron.webp')}
                        alt="FPV Freestyle Drone with Long Range"
                        className="nav__mobile__image"
                      />
                    </div>
                    <span
                      style={{ fontSize: '16px' }}
                      className="nav__mobile__title"
                    >
                      Dream X
                    </span>
                  </NavLink> */}
                  <NavLink
                    to={'/products/fpvonepilot'}
                    onClick={() => {
                      this.handleNavigationClick();
                      this.handleMenuToggle();
                    }}
                    activeClassName="active"
                    onMouseLeave={this.handleBlur}
                    className={`nav__mobile__item ${
                      activeLocation === '/products/fpvonepilot'
                        ? 'nav__mobile__item--active'
                        : ''
                    }`}
                  >
                    <div className="nav__mobile__image--wrapper">
                      <img
                        src={require('main/assets/images/fpvonepilot/fpvone-pilot-navigation.webp')}
                        alt="FPV Goggles Product"
                        className="nav__mobile__image"
                      />
                    </div>
                    <span style={{ fontSize: '16px' }}>FPV.One Pilot</span>
                  </NavLink>
                  {/* <NavLink
                    to="/products/fpvonerace"
                    onClick={() => {
                      this.handleNavigationClick();
                      this.handleMenuToggle();
                    }}
                    onMouseLeave={this.handleBlur}
                    exact
                    activeClassName="active"
                    className={`nav__mobile__item ${
                      activeLocation === '/products/fpvonerace'
                        ? 'nav__mobile__item--active'
                        : ''
                    }`}
                  >
                    <div className="nav__mobile__image--wrapper">
                      <img
                        src={require('main/assets/images/fpvonerace/fpvone-race-navigation.webp')}
                        alt="FPV Headset for Racing Product"
                        className="nav__mobile__image"
                      />
                    </div>
                    <span style={{ fontSize: '16px' }}>FPV.One Race</span>
                  </NavLink> */}
                  <NavLink
                    to="/products/fpvctrl"
                    onClick={() => {
                      this.handleNavigationClick();
                      this.handleMenuToggle();
                    }}
                    onMouseLeave={this.handleBlur}
                    exact
                    activeClassName="active"
                    className={`nav__mobile__item ${
                      activeLocation === '/products/fpvctrl'
                        ? 'nav__mobile__item--active'
                        : ''
                    }`}
                  >
                    <div className="nav__mobile__image--wrapper">
                      <img
                        style={{ objectFit: 'contain' }}
                        src={require('main/assets/images/fpvctrl/fpvctrl-full.webp')}
                        alt="FPV Remote Drone Controller"
                        className="nav__mobile__image"
                      />
                    </div>
                    <span style={{ fontSize: '16px' }}>FPV.Ctrl</span>
                  </NavLink>

                  <NavLink
                    to={'/products/skydive'}
                    onClick={() => {
                      this.handleNavigationClick();
                      this.handleMenuToggle();
                    }}
                    onMouseLeave={this.handleBlur}
                    activeClassName="active"
                    className={`nav__mobile__item ${
                      activeLocation === '/products/skydive'
                        ? 'nav__mobile__item--active'
                        : ''
                    }`}
                  >
                    <div className="nav__mobile__image--wrapper">
                      <img
                        src={require('main/assets/images/skydive/skydive-navigation.webp')}
                        alt="FPV Drone Racing and Freestyle Simulator"
                        className="nav__mobile__image"
                      />
                    </div>
                    <span
                      style={{ fontSize: '16px' }}
                      className="nav__mobile__title"
                    >
                      SkyDive
                    </span>
                  </NavLink>
                  <NavLink
                    to={'/products/drone-soccer'}
                    onClick={() => {
                      this.handleNavigationClick();
                      this.handleMenuToggle();
                    }}
                    onMouseLeave={this.handleBlur}
                    activeClassName="active"
                    className={`nav__mobile__item ${
                      activeLocation === '/products/drone-soccer'
                        ? 'nav__mobile__item--active'
                        : ''
                    }`}
                  >
                    <div className="nav__mobile__image--wrapper">
                      <img
                        src={require('main/assets/images/droneSoccer/drone-soccer-navigation.webp')}
                        alt="Drone Soccer Product"
                        className="nav__mobile__image"
                      />
                    </div>
                    <span
                      style={{ fontSize: '16px' }}
                      className="nav__mobile__title"
                    >
                      Drone Soccer
                    </span>
                  </NavLink>
                  <NavLink
                    to={'/products/fpv-ace'}
                    onClick={() => {
                      this.handleNavigationClick();
                      this.handleMenuToggle();
                    }}
                    onMouseLeave={this.handleBlur}
                    activeClassName="active"
                    className={`nav__mobile__item ${
                      activeLocation === '/products/fpv-ace'
                        ? 'nav__mobile__item--active'
                        : ''
                    }`}
                  >
                    <div className="nav__mobile__image--wrapper">
                      <img
                        src={require('main/assets/images/fpvAce/fpv-ace-navigation.webp')}
                        alt="FPV Drone Bundle for Flight Guide"
                        className="nav__mobile__image"
                        style={{ objectFit: 'contain' }}
                      />
                    </div>
                    <span
                      style={{ fontSize: '16px' }}
                      className="nav__mobile__title"
                    >
                      FPV Ace
                    </span>
                  </NavLink>

                  <NavLink
                    to={'/products/rapid-fire'}
                    onClick={() => {
                      this.handleNavigationClick();
                      this.handleMenuToggle();
                    }}
                    onMouseLeave={this.handleBlur}
                    activeClassName="active"
                    className={`nav__mobile__item ${
                      activeLocation === '/products/rapid-fire'
                        ? 'nav__mobile__item--active'
                        : ''
                    }`}
                  >
                    <div className="nav__mobile__image--wrapper">
                      <img
                        src={require('main/assets/images/rapidFire/rapid-fire-design-details.webp')}
                        alt="RF Drone Detection Product"
                        className="nav__mobile__image"
                        style={{ objectFit: 'contain' }}
                      />
                    </div>
                    <span
                      style={{ fontSize: '16px' }}
                      className="nav__mobile__title"
                    >
                      rapidFIRE
                    </span>
                  </NavLink>
                  <NavLink
                    to={'/products/power-meter-v2'}
                    onClick={() => {
                      this.handleNavigationClick();
                      this.handleMenuToggle();
                    }}
                    onMouseLeave={this.handleBlur}
                    activeClassName="active"
                    className={`nav__mobile__item ${
                      activeLocation === '/products/power-meter-v2'
                        ? 'nav__mobile__item--active'
                        : ''
                    }`}
                  >
                    <div className="nav__mobile__image--wrapper">
                      <img
                        src={require('main/assets/images/powerMeterV2/power-meter-navigation.webp')}
                        alt="Testing control and video RF links for FPV using the Power Meter v2."
                        className="nav__mobile__image"
                      />
                    </div>
                    <span
                      style={{ fontSize: '16px' }}
                      className="nav__mobile__title"
                    >
                      Power Meter v2
                    </span>
                  </NavLink>
                  {/* <NavLink
                    to={'/products/lap-rf'}
                    onClick={() => {
                      this.handleNavigationClick();
                      this.handleMenuToggle();
                    }}
                    onMouseLeave={this.handleBlur}
                    activeClassName="active"
                    className={`nav__mobile__item ${
                      activeLocation === '/products/lap-rf'
                        ? 'nav__mobile__item--active'
                        : ''
                    }`}
                  >
                    <div className="nav__mobile__image--wrapper">
                      <img
                        src={require('main/assets/images/lapRf/immersionrc-lap-rf-top-side.webp')}
                        alt="Device for RF Drone Detection"
                        className="nav__mobile__image"
                        style={{ objectFit: 'contain' }}
                      />
                    </div>
                    <span
                      style={{ fontSize: '16px' }}
                      className="nav__mobile__title"
                    >
                      LapRF
                    </span>
                  </NavLink> */}
                </div>
              </li>

              <li className="nav__links__item">
                <NavLink
                  onMouseLeave={this.handleBlur}
                  to="/news"
                  exact
                  className="nav__link"
                  activeClassName="active"
                  onClick={this.removeBodyLock}
                >
                  News
                </NavLink>
              </li>
              <li className="nav__links__item">
                <NavLink
                  onMouseLeave={this.handleBlur}
                  to="/about"
                  exact
                  className="nav__link"
                  activeClassName="active"
                  onClick={this.removeBodyLock}
                >
                  About
                </NavLink>
              </li>
              <li className="nav__links__item">
                <NavLink
                  onMouseLeave={this.handleBlur}
                  to="/contact"
                  exact
                  className="nav__link"
                  activeClassName="active"
                  onClick={this.removeBodyLock}
                >
                  Contact
                </NavLink>
              </li>
            </ul>
            {/* <div className="social__wrapper">
              <div className="social">
                <a
                  href="https://www.facebook.com/OrqaFPV"
                  target="_blank"
                  rel="noopener noreferrer nofollow nofollow"
                  title="Facebook: ORQA"
                  onMouseDown={event => event.preventDefault()}
                >
                  <img
                    src={facebookIcon}
                    alt="Facebook Social Media Icon"
                    className="header__icon"
                  />
                </a>
                <a
                  href="https://www.instagram.com/orqafpv/"
                  target="_blank"
                  rel="noopener noreferrer nofollow nofollow"
                  title="Instagram: ORQA"
                  onMouseDown={event => event.preventDefault()}
                >
                  <img
                    src={instagramIcon}
                    alt="Instagram Social Media Icon"
                    className="header__icon"
                  />
                </a>
                <a
                  href="https://www.youtube.com/channel/UCGPZJ5j16slPTObilo8viwg/featured"
                  target="_blank"
                  rel="noopener noreferrer nofollow"
                  title="Youtube: ORQA"
                  onMouseDown={event => event.preventDefault()}
                >
                  <img
                    src={youtubeIcon}
                    alt="Youtube Social Media Icon"
                    className="header__icon"
                  />
                </a>
                <a
                  href="https://twitter.com/OrqaFPV"
                  target="_blank"
                  rel="noopener noreferrer nofollow"
                  title="X: ORQA"
                  onMouseDown={event => event.preventDefault()}
                >
                  <img
                    src={xIcon}
                    alt="X Social Media Icon"
                    className="header__icon"
                  />
                </a>
              </div>
            </div> */}
          </div>
          <div>
            <div className="nav__toggle">
              <button
                aria-label="Open Navigation"
                onClick={this.handleMenuToggle}
                className={`hamburger hamburger--elastic ${
                  isMenuToggled ? 'is-active' : ''
                }`}
              >
                <span className="hamburger-box">
                  <span className="hamburger-inner" />
                </span>
              </button>
            </div>
            <div className="nav__proggress--bar">
              <ProgressBar />
            </div>
          </div>
          {/* <PageNavFPVOne />
          <PageNavFPVConnect />
          <PageNavFPVCtrl /> */}
        </nav>
      </>
    );
  }
}

export default withRouter(Navigation);
